// import Hls from 'hls.js'

import { Lightning, Utils } from '@lightningjs/sdk'

import { BrandButtonGrid } from '../components'

export default class Home extends Lightning.Component {
  // Lifecycle
  _onDataProvided() {
    this.configure(this.data)
  }
  configure(globalData) {
    let navItems = []
    globalData.brands.forEach(brand => {
      navItems.push({
        image: brand.logo.url,
        href: brand.href,
        data: brand,
      })
    })
    // if (Hls.isSupported()) {
    //   globalData.videochannels.forEach(videochannel => {
    //     navItems.push({
    //       image: videochannel.logo.url,
    //       href: '/tv/' + videochannel.safeName,
    //       data: videochannel,
    //     })
    //   })
    // }

    this.tag('Menu').items = navItems
  }

  // Template
  static _template() {
    return {
      Background: {
        rect: true,
        src: Utils.asset('background.png'),
        w: 1920,
        h: 1080,
      },
      Logo: {
        src: Utils.asset('logo-large.png'),
        w: 448,
        h: 100,
        x: 60,
        y: 60,
      },
      Text: {
        x: 60,
        y: 204,
        text: {
          text: "Home to some of the UK's best-loved radio stations",
          fontFace: 'Regular',
          fontSize: 34,
          textColor: 0xffffffff,
        },
      },
      Menu: {
        x: 100,
        y: 320,
        w: 1720,
        type: BrandButtonGrid,
      },
    }
  }

  // Event Handlers
  _getFocused() {
    return this.tag('Menu')
  }
}
